// Lightweight scroll animation observer (~0.5KB)
// Replaces Framer Motion's whileInView functionality

const initScrollAnimations = () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          // Once animated, stop observing
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '-50px 0px'
    }
  );

  // Observe all elements with scroll-animate class
  document.querySelectorAll('.scroll-animate').forEach((el) => {
    observer.observe(el);
  });
};

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollAnimations);
} else {
  initScrollAnimations();
}

export default initScrollAnimations;
